import titleImage from '@assets/images/01.png';
import { Link } from 'react-router-dom';
import { Button } from '@/components/Button';
import { Loading } from '@/components/Loading';
import { AuthenticatedButtons } from '@/pages/home/components/AuthenticatedButtons';
import { UnauthenticatedButtons } from '@/pages/home/components/UnauthenticatedButtons';
import { useHomePage } from '@/pages/home/useHomePage';

export const HomePage = () => {
  const {
    isLoading,
    isAuthenticated,
    handleLogin,
    handleStartGame,
    handleLogout,
  } = useHomePage();

  if (isLoading) return <Loading />;

  return (
    <div className="h-svh max-w-full overflow-clip grid place-items-center">
      <div className="text-center grid gap-50 grid-auto-rows-max place-items-center">
        <header className="grid gap-16 place-items-center">
          <div className="flex items-center justify-center w-full relative z-0">
            <img
              src={titleImage}
              alt=""
              className="h-96 w-auto animate-spin absolute left-[-20%] md:left-[-40%] z-[-1]"
            />
            <div className="text-2xl md:text-3xl font-bold grid gap-4 bg-linear-to-br from-yellow-600 via-white to-yellow-600 bg-clip-text text-transparent">
              <h1>
                <span>無性生殖！？</span>
                <span>問山くん</span>
              </h1>
              <p className="text-[0.8em]">𝓢𝓮𝓪𝓼𝓸𝓷 𝟐</p>
              <p className="text-[0.5em]">～美術館デート編～</p>
            </div>
            <img
              src={titleImage}
              alt=""
              className="h-96 w-auto animate-[spin_1s_linear_infinite_reverse] absolute right-[-20%] md:right-[-40%] z-[-1]"
            />
          </div>
        </header>

        <div className="grid gap-24 max-w-200 w-full">
          {isAuthenticated ? (
            <AuthenticatedButtons
              onStartGame={handleStartGame}
              onLogout={handleLogout}
            />
          ) : (
            <UnauthenticatedButtons onLogin={handleLogin} />
          )}
          <Button asChild className="py-[0.8em]">
            <Link to="/results">ランキング</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};
